/**
 * Tetrish - Game State Service
 * Manages the state of the game, including pieces, game status, and settings
 */

export class GameState {
	constructor() {
		this.isGameRunning = false;
		this.isPaused = false;
		this.gameOver = false;
		this.showGhostPiece = true;
		this.currentPiece = null;
		this.nextPiece = null;
		this.heldPiece = null;
		this.hasHeldPiece = false; // Flag to prevent multiple holds per piece
		this.ghostPiecePosition = null;
	}

	/**
	 * Reset the game state to start a new game
	 */
	reset() {
		console.log('Resetting game state');
		this.isGameRunning = false;
		this.isPaused = false;
		this.gameOver = false;
		this.currentPiece = null;
		this.nextPiece = null;
		this.heldPiece = null;
		this.hasHeldPiece = false;
		this.ghostPiecePosition = null;
	}

	/**
	 * Set whether the ghost piece should be displayed
	 */
	setGhostPieceVisibility(visible) {
		this.showGhostPiece = visible;
	}

	/**
	 * Save the current state to local storage
	 */
	saveState() {
		try {
			// We intentionally don't save piece objects as they would be complex to serialize
			const stateToSave = {
				isGameRunning: this.isGameRunning,
				isPaused: this.isPaused,
				gameOver: this.gameOver,
				showGhostPiece: this.showGhostPiece,
				hasHeldPiece: this.hasHeldPiece
			};

			localStorage.setItem('tetrish-game-state', JSON.stringify(stateToSave));
			return true;
		} catch (e) {
			console.error('Error saving game state:', e);
			return false;
		}
	}

	/**
	 * Load a saved state from local storage
	 */
	loadState() {
		try {
			const savedState = localStorage.getItem('tetrish-game-state');
			if (!savedState) return null;

			const parsedState = JSON.parse(savedState);

			// Only restore simple properties, not piece objects
			this.isGameRunning = parsedState.isGameRunning || false;
			this.isPaused = parsedState.isPaused || false;
			this.gameOver = parsedState.gameOver || false;
			this.showGhostPiece = parsedState.showGhostPiece !== undefined ? parsedState.showGhostPiece : true;
			this.hasHeldPiece = parsedState.hasHeldPiece || false;

			return parsedState;
		} catch (e) {
			console.error('Error loading game state:', e);
			return null;
		}
	}

	/**
	 * Clear any saved state
	 */
	clearSavedState() {
		try {
			localStorage.removeItem('tetrish-game-state');
			return true;
		} catch (e) {
			console.error('Error clearing game state:', e);
			return false;
		}
	}
}
